import router from '../routes';
import store from '../store';

export function Api(baseApiUrl, lang) {
    var self = this;
    self.requestsInProcces = 0;
    this.token = null;
    this.uuid = null;

    /**
     *
     * @param $path
     * @param params
     * @returns {*}
     */
    self.get = function($path,params = null) {
        let url = self.apiUrl($path);
        // append the baseData
        if(params) {
            params = _.merge(self.getBaseData(), params);
        } else {
            params = self.getBaseData();
        }

        self.requestsInProcces++;

        return axios.get(url,
            {
                responseType: 'json',
                params: params,
            })
            .catch(error => {
                self.handleError(error,url)
            })
            .finally(() => {
                self.requestsInProcces--;
                store.commit('setLoading',false);
            })

    }

    self.delete = function($path) {
        let url = self.apiUrl($path);

        var params = self.getBaseData();

        self.requestsInProcces++;

        return axios.delete(url,
            {
                responseType: 'json',
                params: params
            })
            .catch(error => {
                self.handleError(error)
            })
            .finally(() => {
                self.requestsInProcces--;
                store.commit('setLoading',false);
            });
    }

    /**
     *
     * @param $path
     * @param data
     * @returns {*}
     */
    self.post = function($path, data = null) {

        // append the baseData
        if(! data) {
            data = new FormData();
        }

        _.each(self.getBaseData(),function(item,key) {
            data.append(key,item);
        });

        self.requestsInProcces++;

        // do the post request
        //  + always allow files to be send
        return axios.post($path, data,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .catch(error => {
                self.handleError(error)
            })
            .finally(() => {
                self.requestsInProcces--;
                store.commit('setLoading',false);
            });
    };

    /**
     *
     * @param url
     * @returns {string}
     */
    self.apiUrl = function (url) {
        return baseApiUrl + store.state.activeLocale + '/api/' + url;
    }

    /**
     *
     * @returns {{token: *, uuid: *}}
     */
    self.getBaseData = function() {
        return {
            token: this.token,
            uuid: this.uuid,
        }
    }

    self.getRequestsInProcces = function() {
        return self.requestsInProcces;
    }

    self.handleError = function(error,url) {
        store.commit('setLoading',false);

        //Fix no response from backend
        if( ! error.response){
          console.log('no responses from backend');
          router.push({name: '500', params:{}});
        }

        // redirect to the correct error page
        if(error.response.data && error.response.data.status && error.response.data.status == 'person-not-found') {
            router.push({name: 'person-not-found', params:{}});
        } else if(error.response.data && error.response.data.status && error.response.data.status == 'link-expired') {
            router.push({name: 'link-expired', params:{}});
        } else if(error.response.data && error.response.data.status &&
            error.response.data.document && error.response.data.status == 'ocr-rejected') {
            router.push({name: 'ocr-rejected', params:{document: error.response.data.document}});
        } else if(error.response.data && error.response.data.status &&
            error.response.data.document && error.response.data.status == 'ocr-id-singel-sided') {
            router.push({name: 'ocr-id-singel-sided', params:{document: error.response.data.document}});
        }
        else if (error.response && error.response.status == 404) {
            router.push({name: '404', params:{}});
        } else {
            router.push({name: '500', params:{}});
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/api.js